import { DashboardNavLink } from "./constants";
import { INavItem } from "../types";

export const navlinks: INavItem = {
  path: `/${DashboardNavLink}`,
  name: 'Dashboard',
  icon: 'DashboardOutlinedIcon',
  title: 'dashboard',
};
